import {
  Badge,
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ScrollArea,
  Typography,
} from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconAlertTriangle } from "@tabler/icons-react";
import { DbtCloudConflictingProject } from "../../../types";

interface ConflictingProjectsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  conflictingProjects: DbtCloudConflictingProject[];
  message: string;
}

const ConflictingProjectsModal = ({
  open,
  onOpenChange,
  conflictingProjects,
  message,
}: ConflictingProjectsModalProps): JSX.Element => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="al-max-w-lg">
        <DialogHeader>
          <Stack direction="row" align="center" gap="sm">
            <IconAlertTriangle className="al-text-destructive" size={24} />
            <DialogTitle>Conflicting Projects Found</DialogTitle>
          </Stack>
        </DialogHeader>
        <Typography size="sm" className="al-text-muted-foreground">
          {message}
        </Typography>
        <ScrollArea className="al-max-h-[40vh] al-pr-4">
          <Stack direction="column" gap="sm">
            {conflictingProjects.map(project => (
              <div
                key={project.external_project_id}
                className="al-border al-border-border al-rounded-lg al-p-3 al-bg-muted/30"
              >
                <Stack direction="row" justify="between" align="center">
                  <Typography weight="medium" size="sm">
                    {project.project_name}
                  </Typography>
                  <Badge variant="outline" className="al-text-xs">
                    ID: {project.external_project_id}
                  </Badge>
                </Stack>
              </div>
            ))}
          </Stack>
        </ScrollArea>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConflictingProjectsModal;
